import React from 'react'
import { Link } from 'react-router-dom'

function Nf() {
  <head></head>
  return (
    <div>
      <h1 
      className='nf_head'
      style=
      {
        {textAlign: 'center'}
      }
      >
        Not Found</h1>
      <Link to="/home" ><button className='button2'>To go back, press this button</button></Link>
    </div>
  )
}

export default Nf
